import { render, staticRenderFns } from "./Similares.vue?vue&type=template&id=ad94ad8e"
import script from "./Similares.vue?vue&type=script&lang=js"
export * from "./Similares.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports